import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { fetchUnassignedJournalMemberships } from 'src/api/queries';

export const LIMIT = 10;

export const useUnassignedMember = (
  workspaceId: string,
  searchValue: string,
  page: number
) => {
  const { journalId } = useParams();

  const query = useQuery({
    retry: 0,
    queryKey: ['unassigned-members', workspaceId, journalId, searchValue, page],
    queryFn: () =>
      fetchUnassignedJournalMemberships({
        workspaceId,
        submissionContextId: journalId || '',
        limit: LIMIT,
        offset: (page - 1) * LIMIT,
        searchParams: searchValue
      }),
    keepPreviousData: true
  });

  return {
    ...query,
    total: query.data?.total ?? 0,
    totalPages: Math.ceil((query.data?.total ?? 0) / LIMIT),
    startIndex: (page - 1) * LIMIT + 1,
    endIndex: Math.min(page * LIMIT, query.data?.total ?? 0),
    currentPageData: query.data?.collection ?? []
  };
};
